<template>
    <div class="farm-tasks-container">
        <div class="page-title">农事任务配置</div>
        <div class="page-content">
            <div class="operation-bar">
                <el-button type="primary" size="mini" @click="handleCreate">+新增</el-button>
                <el-button type="danger" size="mini" @click="handleBatchDelete"
                    :disabled="!selectedRows.length">删除</el-button>
                <div class="search-box">
                    <span style="margin: 0 10px; color: #fff;">状态</span>
                    <el-select v-model="searchStatus" placeholder="请选择" style="width: 200px;" size="mini" clearable>
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                    <el-button icon="el-icon-search" style="margin-left: 10px;" size="mini" type="primary"
                        @click="handleSearch">查询</el-button>
                </div>
            </div>
            <el-table :data="tableData" border style="width: 100%" height="60vh"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index" width="80" align="center">
                </el-table-column>
                <el-table-column prop="categoryName" label="农事任务分类"></el-table-column>
                <el-table-column prop="actions" label="农事动作"></el-table-column>
                <el-table-column prop="enabled" label="启用" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enabled === 1 ? 'success' : 'info'">{{ scope.row.enabled === 1 ? '启用' :
                            '禁用' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" style="color: #2680DD;" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" style="color: #04FF9F;" @click="handleView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </div>

        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="76vw" @close="handleDialogClose">
            <el-form :model="formData" :rules="rules" ref="formRef" label-position="top" label-width="120px">
                <!-- 新增模式：表格形式 -->
                <el-form-item v-if="!isEdit" label="农事任务配置:" prop="details">
                    <div class="config-table">
                        <el-table :data="formData.details" border style="width: 100%">
                            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
                            <el-table-column label="*农事任务分类" width="200">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.categoryId" placeholder="请选择" style="width: 100%;"
                                        @change="handleCategoryChange(scope.$index)">
                                        <el-option v-for="category in categoryOptions" :key="category.id"
                                            :label="category.categoryName" :value="category.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="*农事动作">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.actions" placeholder="请输入"
                                        style="width: 100%;"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="重点防治病虫害">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.pestControl" placeholder="请输入"
                                        style="width: 100%;"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="标准温湿度要求">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.stdHumidityTemp" placeholder="请输入"
                                        style="width: 100%;"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini"
                                        @click="removeDetail(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="add-button-container">
                            <el-button type="primary" icon="el-icon-plus" plain style="margin: 10px 0; width: 100%;" @click="addDetail">添加</el-button>
                        </div>
                    </div>
                </el-form-item>
                
                <!-- 编辑模式：表单形式 -->
                <div v-if="isEdit">
                    <el-form-item label="*农事任务分类:" prop="categoryId">
                        <el-select v-model="formData.categoryId" placeholder="请选择" style="width: 100%;"
                            @change="handleEditCategoryChange">
                            <el-option v-for="category in categoryOptions" :key="category.id"
                                :label="category.categoryName" :value="category.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="*农事动作:" prop="actions">
                        <el-input v-model="formData.actions" placeholder="请输入" style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="重点防治病虫害:" prop="pestControl">
                        <el-input v-model="formData.pestControl" placeholder="请输入" style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="标准温湿度要求:" prop="stdHumidityTemp">
                        <el-input v-model="formData.stdHumidityTemp" placeholder="请输入" style="width: 100%;"></el-input>
                    </el-form-item>
                </div>
                
                <el-form-item label="状态:" prop="enabled">
                    <el-switch v-model="formData.enabled" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 查看详情弹窗 -->
        <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="600px">
            <div>
                <p><strong>农事任务分类：</strong>{{ viewRow.categoryName }}</p>
                <p><strong>农事动作：</strong>{{ viewRow.actions }}</p>
                <p><strong>重点防治病虫害：</strong>{{ viewRow.pestControl }}</p>
                <p><strong>标准温湿度要求：</strong>{{ viewRow.stdHumidityTemp }}</p>
                <p><strong>状态：</strong>{{ viewRow.enabled === 1 ? '启用' : '禁用' }}</p>
                <p><strong>创建时间：</strong>{{ formatTime(viewRow.createTime) }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from '@/axios'
import { baseUrl } from '@/axios/baseUrl'

export default {
    name: 'FarmTasksManagement',
    data() {
        return {
            tableData: [],
            selectedRows: [],
            searchStatus: '',
            page: 1,
            pageSize: 10,
            totalCount: 0,
            dialogVisible: false,
            dialogTitle: '新增农事任务配置',
            formData: {
                id: null,
                details: [],
                enabled: 1,
                // 编辑时的字段
                categoryId: '',
                categoryName: '',
                actions: '',
                pestControl: '',
                stdHumidityTemp: ''
            },

            isEdit: false,
            rules: {
                details: [
                    { required: true, message: '请配置农事任务', trigger: 'change' }
                ]
            },
            viewDialogVisible: false,
            viewRow: {},
            categoryOptions: []
        }
    },
    created() {
        this.fetchData()
        this.fetchCategoryOptions()
    },
    methods: {
        async fetchData() {
            try {
                const params = {
                    page: this.page,
                    pageSize: this.pageSize,
                    enabled: this.searchStatus,
                }
                
           
                
                const res = await axios.post(baseUrl + '/api/farming/task-config/list-page', params)
                if (res.code === 200) {
                    this.tableData = res.data.list || []
                    this.totalCount = parseInt(res.data.totalCount) || 0
                }
            } catch (error) {
            }
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection
        },
        handleSearch() {
            this.page = 1
            this.fetchData()
        },
        handleCreate() {
            this.isEdit = false
            this.dialogTitle = '新增农事任务配置'
            this.dialogVisible = true
            
            // 先设置数据
            this.formData = {
                id: null,
                details: [],
                enabled: 1,
                // 编辑时的字段
                categoryId: '',
                categoryName: '',
                actions: '',
                pestControl: '',
                stdHumidityTemp: ''
            }
            
            // 然后打开弹窗并重置表单验证状态
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.resetFields()
                // 添加一个默认行
                this.addDetail()
            })
        },
                handleEdit(row) {
            this.isEdit = true
            this.dialogTitle = '编辑农事任务配置'
            this.dialogVisible = true
            
            // 先设置数据
            this.formData = { 
                id: row.id,
                enabled: row.enabled,
                details: [],
                // 编辑时的字段
                categoryId: row.categoryId,
                categoryName: row.categoryName,
                actions: row.actions,
                pestControl: row.pestControl,
                stdHumidityTemp: row.stdHumidityTemp
            }
            
            // 然后打开弹窗并重置表单验证状态
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.clearValidate()
            })
        },
        handleView(row) {
            this.viewRow = { ...row }
            this.viewDialogVisible = true
        },
        handleDialogClose() {
            this.$refs.formRef && this.$refs.formRef.resetFields()
            this.isEdit = false
            this.formData = {
                id: null,
                details: [],
                enabled: 1,
                // 编辑时的字段
                categoryId: '',
                categoryName: '',
                actions: '',
                pestControl: '',
                stdHumidityTemp: ''
            }
        },
        async handleSubmit() {
            if (this.isEdit) {
                // 编辑模式：使用表单验证
                this.$refs.formRef.validate(async (valid) => {
                    if (valid) {
                        try {
                            const editData = {
                                id: this.formData.id,
                                categoryId: this.formData.categoryId,
                                categoryName: this.formData.categoryName,
                                actions: this.formData.actions,
                                pestControl: this.formData.pestControl,
                                stdHumidityTemp: this.formData.stdHumidityTemp,
                                enabled: this.formData.enabled
                            }
                            console.log(editData);
                            
                            const res = await axios.post(baseUrl + '/api/farming/task-config/edit', editData)
                            if (res.code === 200) {
                                this.$message.success('更新成功')
                                this.dialogVisible = false
                                this.fetchData()
                            }
                        } catch (error) {
                        }
                    }
                })
            } else {
                // 新增模式：自定义验证
                if (!this.formData.details || this.formData.details.length === 0) {
                    this.$message.error('请至少添加一条农事任务配置')
                    return
                }
                
                // 验证每个详情项
                for (let i = 0; i < this.formData.details.length; i++) {
                    const detail = this.formData.details[i]
                    if (!detail.categoryId) {
                        this.$message.error(`第${i + 1}行：请选择农事任务分类`)
                        return
                    }
                    if (!detail.actions) {
                        this.$message.error(`第${i + 1}行：请输入农事动作`)
                        return
                    }
                    // 移除重点防治病虫害和标准温湿度要求的必填验证
                }
                
                try {
                    // 新增：批量数据
                    const items = this.formData.details.map(detail => ({
                        categoryId: detail.categoryId,
                        categoryName: detail.categoryName,
                        actions: detail.actions,
                        pestControl: detail.pestControl,
                        stdHumidityTemp: detail.stdHumidityTemp,
                        enabled: this.formData.enabled
                    }))
                    const res = await axios.post(baseUrl + '/api/farming/task-config/add-batch', { items })
                    if (res.code === 200) {
                        this.$message.success('新增成功')
                        this.dialogVisible = false
                        this.fetchData()
                    }
                } catch (error) {
                }
            }
        },
        async handleBatchDelete() {
            if (!this.selectedRows.length) return
            try {
                await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个配置吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                const ids = this.selectedRows.map(row => row.id)
                const res = await axios.post(baseUrl + '/api/farming/task-config/delete-batch', ids)
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.fetchData()
                }
            } catch (error) {
                if (error !== 'cancel') {
                }
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.page = val
            this.fetchData()
        },
        formatTime(time) {
            if (!time) return ''
            const date = new Date(time)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).replace(/\//g, '/')
        },
        // 获取农事任务分类选项
        async fetchCategoryOptions() {
            try {
                const res = await axios.post(baseUrl + '/api/basic/farming-category/selection')
                if (res.code === 200) {
                    this.categoryOptions = res.data.map(item => ({
                        id: item.id,
                        categoryName: item.categoryName,
                        actions: item.actions,
                        pestControl: item.pestControl,
                        stdHumidityTemp: item.stdHumidityTemp
                    }))
                }
            } catch (error) {
            }
        },
        // 农事任务分类变化处理
        handleCategoryChange(index) {
            const detail = this.formData.details[index]
            const selectedCategory = this.categoryOptions.find(item => item.id === detail.categoryId)
            if (selectedCategory) {
                detail.categoryName = selectedCategory.categoryName
                detail.actions = selectedCategory.actions
                detail.pestControl = selectedCategory.pestControl
                detail.stdHumidityTemp = selectedCategory.stdHumidityTemp
            }
        },
        // 编辑模式农事任务分类变化处理
        handleEditCategoryChange() {
            const selectedCategory = this.categoryOptions.find(item => item.id === this.formData.categoryId)
            if (selectedCategory) {
                this.formData.categoryName = selectedCategory.categoryName
                this.formData.actions = selectedCategory.actions
                this.formData.pestControl = selectedCategory.pestControl
                this.formData.stdHumidityTemp = selectedCategory.stdHumidityTemp
            }
        },
        // 添加详情行
        addDetail() {
            this.formData.details.push({
                id: undefined,
                categoryId: '',
                categoryName: '',
                actions: '',
                pestControl: '',
                stdHumidityTemp: ''
            })
        },
        // 删除详情行
        removeDetail(index) {
            this.formData.details.splice(index, 1)
        },
       
    }
}
</script>

<style scoped lang="less">
.farm-tasks-container {
    .page-title {
        font-size: 20px;
        color: #fff;
        margin-bottom: 20px;
    }

    .page-content {
        background: rgba(0, 11, 47, 0.3);
        padding: 20px;
        border-radius: 4px;

        .operation-bar {
            margin-bottom: 20px;
            display: flex;
            align-items: center;

            .search-box {
                margin-left: auto;
                display: flex;
                align-items: center;
            }
        }

        .pagination-container {
            margin-top: 20px;
            text-align: right;
        }

        .config-table {
            .add-button-container {
                margin-top: 15px;
                text-align: center;
                padding: 15px;
                border: 2px dashed #dcdfe6;
                border-radius: 4px;
                background-color: #fafafa;
            }
        }
    }
}
</style>